
export default function ServicesBanner() {
  return (
    <>
    <section className="aboutpage-banner">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="aboutbanner-box">
                      <div className="aboutbanner-tittle">
                        <h1 className="heading">Our Interior Design Services</h1>
                        <span>Interior Geniuses</span>
                      </div>

                      <div className="servicebanner-para">
                          <p>Your dream interior realized through expert craftsmanship, premium materials, and precise, seamless project execution.</p>
                          <ul>
                            <li>1.Modular Work</li>
                            <li>2.Mill Work</li>
                            <li>3.Bespoke Furniture</li>
                            <li>4.Turnkey Solutions</li>
                          </ul>
                      </div>
                    </div>
                </div>
    
            </div>
        </div>

        <img src="/image/service-banner.webp" className="banner-aboutimage" alt="service"/>
        <div className="banner-topoverlay"></div>
    </section>  
    </>
  )
}
